module.exports = __webpack_public_path__ + "img/95-Noce Sorrento Natur.jpg";